import { Heading } from 'theme-ui';
import { Shift } from '@velove/types';

import { getCancelationReasonLabel } from '../../helpers/labels';

import CardRow from './CardRow';
import CardLabel from './CardLabel';
import CardValue from './CardValue';
import ShiftCard, { ShiftCardProps } from './ShiftCard';

export interface CanceledShiftCardProps extends Omit<ShiftCardProps, 'availableShift' | 'labels' | 'status'> {
  labels: ShiftCardProps['labels'] & {
    cancelationHeader: string;
    cancelationReason: string;
  };
  shift: Shift;
}

const CanceledShiftCard: React.FC<CanceledShiftCardProps> = ({ labels, shift, ...props }) => (
  <ShiftCard
    {...props}
    availableShift={shift.availableShift}
    header={
      <Heading as="h4" variant="heading2" sx={{ textAlign: 'center', my: 0 }}>
        {labels.cancelationHeader}
      </Heading>
    }
    labels={labels}
    rows={
      <CardRow>
        <CardLabel>{labels.cancelationReason}</CardLabel>
        <CardValue>{shift.cancelReason ? getCancelationReasonLabel(shift.cancelReason) : '-'}</CardValue>
      </CardRow>
    }
    status="CANCELED"
  />
);

export default CanceledShiftCard;
